import { render, staticRenderFns } from "./TraceabilityEditExamDataModal.vue?vue&type=template&id=4a763283&scoped=true"
import script from "./TraceabilityEditExamDataModal.vue?vue&type=script&lang=js"
export * from "./TraceabilityEditExamDataModal.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityEditExamDataModal.vue?vue&type=style&index=0&id=4a763283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a763283",
  null
  
)

export default component.exports